import roles from './roles.enum';

const AdminRules = {
  AdminOTPRules: [roles.superadmin],
  UpdatePhoneNumver: [roles.superadmin],
};

export default AdminRules;
